export const t = {
    en: {
        nav: {
            home: "Home",
            about: "About",
            skills: "Skills",
            projects: "Projects",
            experience: "Experience",
            contact: "Contact",
        },
        hero: {
            subtitle: "Software Engineer",
            description: "I build full-stack apps and the automation behind them.",
            downloadResume: "Download Resume",
            contactMe: "Contact Me",
        },
        about: {
            title: "About Me",
            p1: "I'm a software engineer based in Tunisia. After a bachelor's in computer science engineering, I'm now in a masters program specializing in computer security.",
            p2: "I work across the stack, web and mobile front-ends, the APIs behind them, and the automation and AI layers that tie them together. I care about interfaces that feel effortless, code that stays maintainable as it grows, and tools that genuinely save people time.",
            facts: ["Full-Stack Development", "AI & LLM Integration", "Security & Automation", "Clean, Accessible UI"],
        },
        skills: {
            title: "Skills Galaxy",
            instruction: "Click & drag to explore · Scroll to zoom",
        },
        projects: {
            title: "Projects",
            close: "Close",
            viewOnGithub: "View on GitHub →",
            liveDemo: "Live Demo →",
            builtWith: "Built with:",
            techStack: "Tech Stack:",
            clickDetails: "Click to view full details...",
        },
        experience: {
            title: "Professional Experiences",
            clickDetails: "Click to view full details...",
            privateRepo: "Private Repository",
        },
        contact: {
            title: "Let's Connect",
            infoTitle: "Contact Information",
            connectTitle: "Connect With Me",
            downloadResume: "Download Resume",
            rightsReserved: "All rights reserved.",
            blurb: "I'm always interested in hearing about new opportunities and exciting projects.",
            cta: "Don't hesitate to reach out!",
        },
        footer: {
            role: "Software Engineer",
            rights: "All rights reserved.",
        },
    },

    fr: {
        nav: {
            home: "Accueil",
            about: "À Propos",
            skills: "Compétences",
            projects: "Projets",
            experience: "Expérience",
            contact: "Contact",
        },
        hero: {
            subtitle: "Ingénieur Logiciel",
            description: "Je conçois des applications full-stack et l'automatisation qui les accompagne.",
            downloadResume: "Télécharger CV",
            contactMe: "Me Contacter",
        },
        about: {
            title: "À Propos",
            p1: "Je suis ingénieur logiciel basé en Tunisie. Après une licence en informatique et génie logiciel, je poursuis un cycle d'ingénieur spécialisé en sécurité informatique.",
            p2: "Je travaille sur toute la stack, interfaces web et mobiles, APIs qui les alimentent, et les couches d'automatisation et d'IA qui relient le tout. J'attache de l'importance aux interfaces fluides, à un code qui reste maintenable, et aux outils qui font réellement gagner du temps.",
            facts: ["Développement Full-Stack", "Intégration IA & LLM", "Sécurité & Automatisation", "UI propres et accessibles"],
        },
        skills: {
            title: "Galaxie de Compétences",
            instruction: "Cliquer & glisser pour explorer · Défiler pour zoomer",
        },
        projects: {
            title: "Projets",
            close: "Fermer",
            viewOnGithub: "Voir sur GitHub →",
            liveDemo: "Démo en direct →",
            builtWith: "Réalisé avec :",
            techStack: "Technologies :",
            clickDetails: "Cliquer pour voir les détails...",
        },
        experience: {
            title: "Expériences Professionnelles",
            clickDetails: "Cliquer pour voir les détails...",
            privateRepo: "Dépôt Privé",
        },
        contact: {
            title: "Prenons Contact",
            infoTitle: "Informations de Contact",
            connectTitle: "Me Suivre",
            downloadResume: "Télécharger CV",
            rightsReserved: "Tous droits réservés.",
            blurb: "Je suis toujours intéressé par de nouvelles opportunités et des projets stimulants.",
            cta: "N'hésitez pas à me contacter !",
        },
        footer: {
            role: "Ingénieur Logiciel",
            rights: "Tous droits réservés.",
        },
    },
};
